module.exports = __webpack_public_path__ + "ae4795344e74e7707b8cfe7b2a4cf9b8.pdf";